import React from 'react';

import styles from 'iss/styles/Box.styl';

function Box(props) {
  return <div {...props} className={styles.box} />;
}

export default Box;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/Box.jsx